import { AddChannelScreenNavigationProps } from "./types"
import React from "react"
import AddChannel from "./add-channel-screen"
import { PageRoot } from "~screens/page-root"


const AddChannelScreen: React.FC<AddChannelScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <AddChannel />
    </PageRoot>
  )
}

export default AddChannelScreen
